import { observable, action } from 'mobx';
import { UserManager, MetadataService, Log } from 'oidc-client';
import * as oidcConfig from '../services/oidc/oidc.config.json';
import agent from '../services/web/agent';
import translationsStore from './translationsStore';

let oidcBaseUrl = window.location.origin + window.location.pathname.slice(0, window.location.pathname.length -1);
oidcConfig.authority = oidcBaseUrl + '/identity';
oidcConfig.redirect_uri = oidcBaseUrl + oidcConfig.redirect_relative_uri;
oidcConfig.silent_redirect_uri = oidcBaseUrl + oidcConfig.silent_redirect_relative_uri;
oidcConfig.post_logout_redirect_uri = oidcBaseUrl + oidcConfig.post_logout_redirect_relative_uri;

let userManager = new UserManager(oidcConfig);
let metadataService = new MetadataService(oidcConfig);



class OIDCStore {

    @observable currentUser;
    @observable loadingError;
    @observable oidcError;
    @observable authorizationEndpoint;
    @observable isUserIdle = false;
    @observable isSessionRenewInProgress = false;

    constructor() {
        let _this = this;
        userManager.events.addUserLoaded(function () {
            _this.loadUser();
        });

        userManager.events.addUserSignedOut(function () {
            
            _this.reloadPageWithNewToken();
        });

        userManager.events.addAccessTokenExpiring(function () {
            if(!_this.isUserIdle){
                _this.startSilentRenew();
            }
        });

        _this.loadUser();
        _this.oidcConfig = oidcConfig;
    }

    @action setUserIdle(isUserIdle) {
        
        this.isUserIdle = isUserIdle;
    }

    @action setSessionRenewInProgress(isSessionRenewInProgress) {
        
        this.isSessionRenewInProgress = isSessionRenewInProgress;
    }

    @action reloadPageWithNewToken() {
        
        userManager.removeUser();
        this.startLogin();
    }

    @action startLogin() {
        
        let originalUrl = window.location.href;
        return userManager.signinRedirect({ state: { originalUrl: originalUrl } });
    }

    @action completeLogin() {

            var query = window.location.href.split('?').slice(1).join('?');
            return userManager.signinRedirectCallback(query);
        }

    @action loadUser() {

        let _this = this;
        
        userManager.getUser().then(function (user) {
	        
            if(user){ 
                translationsStore.setLanguage(user.profile.locale);               
            }        
            _this.currentUser = user;
        });
    }

    @action startSilentRenew() {
        
        return userManager.signinSilent();
    }

    @action completeSilentRenew() {

        var query = window.location.href.split('?').slice(1).join('?');
        userManager.signinSilentCallback(query);
    }

    @action logout() {
        return userManager.signoutRedirect();
    }

    @action getError(errorId) {
        
        this.loadingError = true;
        let _this = this;

        return agent.OidcErrors.getOidcError(errorId)
            .then(action(function (error) {
                
                _this.oidcError = error;
            }))
            .finally(action(() => { 
                
                this.loadingError = false;
            }));
    }

    @action getAuthorizationEndpoint() {
        
        let _this = this;

        return metadataService.getAuthorizationEndpoint().then(authorizationEndpoint => {
                _this.authorizationEndpoint = authorizationEndpoint;
        });
    }
}

export default new OIDCStore();